<div class="overflow-auto pb-3" role="main" aria-label="Home Page" *ngIf="outcome">
  <div [class.welcome-container-newUser]="newUser" role="region" aria-label="Heading-container" [class.welcome-container]="!newUser">
    <div class="welcome-user-name-padding top-heading content-blue singleLine" role="heading" aria-level="2" [innerHTML]="header"></div>
    <div class="padding-container-info">
      <div class="flex-display">
        <div class="mr-6px"><img src="../../../assets/icons/Info..svg" class="info-img" alt="GARS Info"></div>
        <div class="highlight-blue font-16 content-blue">{{infoUpdatedDate}}</div>
      </div>
      <div><span class="highlight-blue font-16 content-blue mt-0-5" [innerHTML]="infoPdfUpdate"> </span>&nbsp;<span><a [routerLink]="['/TocLinks']">{{infoPdfUpdatelinkText}}</a>{{infoDot}}</span></div>
      <div *ngIf="launchmessage.changingThisBreaksApplicationSecurity.length != 0 !='' && accessType == 'Professional' && !maintenanceFlag" [innerHTML]="launchmessage">
      </div>
      <div *ngIf="maintenanceFlag && maintenanceMessage.length != 0" (click)="NavigateToNotificationLink($event)" [innerHTML]="maintenanceMessage">
      </div>
    </div>
    <div class="padding-container flex-display" *ngIf="newUser">
      <div class="app-intro-help">
        <div class="questionHome font-18 content-blue">
          {{whatIsCod}}
        </div>
        <div class="answerHome font-16 content-blue width-80">
          {{whatIsCodDesc}}
        </div>
      </div>
      <div class="app-intro-help">
        <div class="questionHome font-18 content-blue">
          {{howToUse}}
        </div>
        <div class="answerHome font-16 content-blue width-80">
          <span>{{howToUseDescArr1}}</span>
          <span id="/help" (click)="openLinkById($event)" (contextmenu)="onRightClick($event)" class="highlight-blue border-bottom-help cursor-pointer singleLine">{{helpTopicText}}</span>
          <span>{{howToUseDescArr2}}</span>
          <span id="Basic_View_user_guide.pdf" class="highlight-blue border-bottom-help cursor-pointer singleLine" (click)="openLinkById($event,true)" (contextmenu)="onRightClick($event,'SitesPdf')">{{proViewUserGuide}}</span>
          <span>{{howToUseDescArr3}}</span>
        </div>
        <div class="help-topic-container h-20px highlight-blue flex-display cursor-pointer" (click)="openLinkById($event,true)" (contextmenu)="onRightClick($event,'SitesPdf')">
          <div id="FASB_Codification_Notice_to_Constituents_V4.10_0.pdf" class="border-bottom-help">How to use GARS</div> <div class="ml-6px"><img id="FASB_Codification_Notice_to_Constituents_V4.10_0.pdf" src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="HowToUseCors"></div>
        </div>
      </div>
    </div>
    <div class="content-blue highlight-blue aboutGars-padding-container">
      <div class="welcome-title-text georgiaRegularFont aboutGarsHeader-container">{{AboutGars}}</div>
      {{description}}
    </div>
  </div>
  <div class="history-container flex-display" *ngIf="!basicView && accessType != 'Academic'">
    <div class="history-box">
      <div class="history-heading flex-display">
        <div>
          <img src="../../../assets/icons/clock-circle-black.svg" class="watch-image image-info" alt="History">
        </div>
        <div class="history-title-text content-blue">
          {{history}}
        </div>
      </div>
      <div class="mt-1rem content-blue highlight-blue width-80">
        {{historyDesc}}
      </div>
      <div *ngIf="!newUser">
        <div *ngFor="let history of myHistory" class="history-content pl-18px">
          <div class="font-14 recentDate">{{history.recentDate | date:'longDate'}}</div>
          <div class="flex-display history-breadcrumb" *ngIf="history.historyType != 'Bookmark' && history.historyType != 'Annotation'">
            <div *ngFor="let breadcrumbParts of history.breadCrumb.toString().split('~')">
              <div *ngIf="breadcrumbParts != history.breadCrumb.toString().split('~')[history.breadCrumb.toString().split('~').length-1]" class="flex-display font-14">
                <span [innerHTML]="breadcrumbParts | shortText : 30"></span>
                <span *ngIf="breadcrumbParts != history.breadCrumb.toString().split('~')[history.breadCrumb.toString().split('~').length-2]"><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right"></span>
                <span *ngIf="breadcrumbParts == history.breadCrumb.toString().split('~')[history.breadCrumb.toString().split('~').length-2]"><img class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right"></span>
              </div>
            </div>
          </div>
          <div class="flex-display" [class.mt-8px]="history.historyType == 'Bookmark' || history.historyType == 'Annotation'" [class.mt-4px]="history.historyType != 'Bookmark' && history.historyType != 'Annotation'">
            <div *ngIf="history.historyType== 'Bookmark'">
              <img src="../../../assets/icons/OpenBook-black.svg" class="history-type-images" alt="Bookmark">&nbsp;&nbsp;
            </div>
            <div *ngIf="history.historyType== 'Annotation'">
              <img src="../../../assets/icons/pencil-alt.svg" class="history-type-images" alt="Annotation">&nbsp;&nbsp;
            </div>
            <div>
              <a class="font-18 highlight-blue cursor-pointer" (click)="redirectToHistoryUrl(history,$event)" (contextmenu)="onRightClick($event,history)">
                {{history.historyTitle}}
              </a>
            </div>
          </div>
        </div>
        <div class="mt-40px h-20px highlight-blue flex-display">
          <a class="pdf-link" [routerLink]="['/MyHistory']" (keyup.enter)="ViewCompleteHistory()" tabindex="0">{{completeHistory}}</a><div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="History"></div>
        </div>
      </div>
    </div>
    <div class="history-box" *ngIf="accessType == 'Professional'">
      <div class="history-heading flex-display">
        <img src="../../../assets/icons/bookmark-home.svg" class="history-image image-info" alt="Bookmark">
        <div class="history-title-text content-blue">
          {{bookmark}}
        </div>
      </div>
      <div class="mt-1rem content-blue highlight-blue width-80">
        {{bookmarkDesc}}
      </div>
      <div *ngIf="!newUser">
        <div *ngFor="let bookmark of topBookmark" class="history-content pl-18px">
          <div class="font-14 recentDate">{{bookmark.recentDate | date:'longDate'}}</div>
          <div class="flex-display history-breadcrumb mt-4px">
            <div *ngFor="let breadcrumbParts of bookmark.breadCrumb.toString().split('~')">
              <div *ngIf="breadcrumbParts != bookmark.breadCrumb.toString().split('~')[bookmark.breadCrumb.toString().split('~').length]" class="flex-display font-14">
                <span [innerHTML]="breadcrumbParts | shortText : 30"></span>
                <span *ngIf="breadcrumbParts != bookmark.breadCrumb.toString().split('~')[bookmark.breadCrumb.toString().split('~').length-1]"><img src="../../../assets/icons/Arrow Right (Alt).svg" class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right"></span>
                <span *ngIf="breadcrumbParts == bookmark.breadCrumb.toString().split('~')[bookmark.breadCrumb.toString().split('~').length-1]"><img src="../../../assets/icons/Arrow RightDown (Alt).svg" class="breadcrumbArrow overlay-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right"></span>
              </div>
            </div>
          </div>
          <div class="flex-display mt-8px">
            <div>
              <a class="font-18 highlight-blue cursor-pointer" (click)="redirectToBookmarkUrl(bookmark,$event)" (contextmenu)="onRightClick($event,bookmark)">
                {{bookmark.historyTitle}}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="viewAllHistory" *ngIf="!newUser">
        <div class="help-topic-container highlight-blue h-20px flex-display cursor-pointer">
          <a class="pdf-link" [routerLink]="['/myBookmarks']" (click)="ViewAllBookmark()">{{viewAllBookmark}}</a> <div class="ml-6px"><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="History"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="new-update-container flex-display">
    <div class="history-box">
      <div class="history-heading">
        <div class="history-title-text content-blue">
          {{whatsNew}}
        </div>
      </div>
      <div class="mt-1rem content-blue highlight-blue width-80">
        {{whatsNewDesc}}
      </div>
      <div *ngFor="let whatsnew of whatsNewContent" class="mt-1rem">
        <div class="mb-24px">
          <div class="font-18 flex-display width-80">
            <ng-container *ngIf="whatsnew.link; else noLink">
              <span class="highlight-blue cursor-pointer">
                <a [href]="whatsnew.link" target="_blank" [innerHTML]="whatsnew.linktext"></a>&nbsp;
                <img src="../../../assets/icons/new-window-blue.svg" class="whatsNew-image image-info" alt="PDF">
              </span>
            </ng-container>
            <ng-template #noLink>
              <span [innerHTML]="whatsnew.linktext" class="font-16 font-family"></span>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="mt-1rem content-blue highlight-blue width-80">
        {{whatsNewDescOP}}
      </div>
      <div *ngFor="let whatsnew of whatsNewContentOP" class="mt-1rem">
        <div class="mb-24px">
          <div class="font-18 flex-display width-80">
            <ng-container *ngIf="whatsnew.link; else noLink">
              <span class="highlight-blue cursor-pointer">
                <a [href]="whatsnew.link" target="_blank" [innerHTML]="whatsnew.linktext"></a>&nbsp;
                <img src="../../../assets/icons/new-window-blue.svg" class="whatsNew-image image-info" alt="PDF">
              </span>
            </ng-container>
            <ng-template #noLink>
              <span [innerHTML]="whatsnew.linktext" class="font-16 font-family"></span>
            </ng-template>
          </div>
        </div>
      </div>
      <div>
        <div *ngFor="let whatsnew1 of whatsNewContent1" class="help-topic-container h-20px flex-display">
          <div class="singleLine flex-display"> <a [href]="whatsnew1.externalLink" [target]="_blank">{{whatsnew1.fileName}}</a><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="link go to"></div>
        </div>
        <div *ngFor="let whatsnew2 of whatsNewContent2" class="help-topic-container h-20px highlight-blue flex-display cursor-pointer">
          <a [routerLink]="['/finalpronouncements']" (click)="NavigateToFinalPronouncement()" class="singleLine flex-display">{{whatsnew2.fileName}}</a><div class="ml-6px"><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="link go to"></div>
        </div>

      </div>
      <div class="mt-2-5rem"><span class="highlight-blue font-16 content-blue mt-0-5" [innerHTML]="infoPdfUpdate"> </span>&nbsp;<span><a [routerLink]="['/TocLinks']">{{infoPdfUpdatelinkText}}</a>{{infoDot}}</span></div>
    </div>
          <div class="history-box">
            <div class="history-heading flex-display">
              <div class="history-title-text content-blue">
                {{helpTitle}}
              </div>
            </div>
            <div class="mt-1rem content-blue highlight-blue width-80">
              {{helpDescription}}
            </div>
            <div class="help-topic-container h-20px highlight-blue flex-display cursor-pointer">
              <a [routerLink]="['/help']" tabindex="0" (keyup.enter)="NavigateToHelp()">{{helpTopics.linkText}}</a> <div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image" alt="Help Topics"></div>
            </div>
            <div *ngIf="accessType == 'Professional'">
              <div class="help-topic-container h-20px  flex-display" tabindex="0">
                <a class="cursor-pointer" (click)="ResetPassword()" (keyup.enter)="ResetPassword()">{{resetPassword}}</a><div><img src="../../../assets/icons/arrow-right-blue.svg" class="arrow-right-image ml-6px" alt="licensee"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
